/**
 * @generated SignedSource<<9f5ba8e3857088031ea7ad59e171792b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type editVariantDialogQuery$variables = {
  salesChannelID: string;
  sku: string;
};
export type editVariantDialogQuery$data = {
  readonly merchantProductOptions: ReadonlyArray<{
    readonly label: string;
    readonly optionID: string;
    readonly values: ReadonlyArray<{
      readonly label: string;
      readonly valueID: string;
    }>;
  }>;
};
export type editVariantDialogQuery = {
  response: editVariantDialogQuery$data;
  variables: editVariantDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sku"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      },
      {
        "kind": "Variable",
        "name": "sku",
        "variableName": "sku"
      }
    ],
    "concreteType": "MerchantProductGraphQLOption",
    "kind": "LinkedField",
    "name": "merchantProductOptions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optionID",
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantProductGraphQLOptionValue",
        "kind": "LinkedField",
        "name": "values",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueID",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "editVariantDialogQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "editVariantDialogQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cbc8ceddb86056cd99721cff1410e075",
    "id": null,
    "metadata": {},
    "name": "editVariantDialogQuery",
    "operationKind": "query",
    "text": "query editVariantDialogQuery(\n  $sku: String!\n  $salesChannelID: ID!\n) {\n  merchantProductOptions(sku: $sku, salesChannelID: $salesChannelID) {\n    optionID\n    label\n    values {\n      valueID\n      label\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e7a68a9051fb59c13da11f83cb6e559";

export default node;
